import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SwitchCameraSolidIcon(props, ref) {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.293 2.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 1 1-1.414-1.414L16.586 6H6a2 2 0 0 0-2 2v7a1 1 0 1 1-2 0V8a4 4 0 0 1 4-4h10.586l-.293-.293a1 1 0 0 1 0-1.414ZM18 18H7.414l.293-.293a1 1 0 1 0-1.414-1.414l-2 2a1 1 0 0 0 0 1.414l2 2a1 1 0 0 0 1.414-1.414L7.414 20H18a4 4 0 0 0 4-4V9a1 1 0 1 0-2 0v7a2 2 0 0 1-2 2Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    })]
  });
}
;
SwitchCameraSolidIcon.displayName = "SwitchCameraSolidIcon";
export default forwardRef(SwitchCameraSolidIcon);